import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { TitleWithIcon } from 'components/common';
import { Icon } from 'components/common/icons';

import type { AdminGroup } from 'shared-types';

interface Props {
  adminGroup: AdminGroup;
  enableLink?: boolean;
  hideLock?: boolean;
  titleOnly?: boolean;
}
const AdminGroupAvatar = ({
  adminGroup,
  enableLink = true,
  hideLock = false,
  titleOnly = false
}: Props) => {
  const {
    messages,
    user,
    serverConfig: { userUseName }
  } = useReduxState();

  const title =
    adminGroup.id === 1 ? messages.adminGroupsAllAdmins : adminGroup.title;

  const tooltip = adminGroup.addedUsers
    .map((user) =>
      userUseName ? `${user.firstName} ${user.lastName}` : user.email
    )
    .join(', ');

  return (
    <div className="avatar-container">
      <TitleWithIcon
        icon="users"
        title={title}
        {...(adminGroup.isEditable &&
        enableLink &&
        user?.roles.includes('superadmin')
          ? {
              titleLink: {
                as: `/admin/admin-groups/${adminGroup.id}`,
                href: '/admin/admin-groups/[adminGroupId]'
              }
            }
          : {})}
        {...(titleOnly ? { style: { alignItems: 'center' } } : {})}
      >
        {titleOnly ? null : (
          <div
            style={{ display: 'inline-block' }}
            {...(tooltip
              ? { 'aria-label': tooltip, 'data-tooltip': tooltip }
              : {})}
          >
            {getMessageWithPlaceholders({
              message: messages.adminGroupAdmins,
              placeholders: {
                numberOfAdmins: adminGroup.addedUsers.length
              }
            })}
          </div>
        )}
      </TitleWithIcon>

      {!adminGroup.isEditable && !hideLock ? (
        <div
          className="non-editable"
          aria-label={messages.adminGroupNonEditable}
          data-tooltip={messages.adminGroupNonEditable}
        >
          <Icon icon="lock" />
        </div>
      ) : null}

      <style jsx>{`
        .avatar-container {
          align-items: center;
          display: flex;
        }
        .non-editable {
          font-size: 1.1rem;
          margin-left: 4px;
          padding: 3px 5px;
        }
      `}</style>
    </div>
  );
};

export default AdminGroupAvatar;
